import { db } from "../../../boot/firebase";
import { addDoc, collection } from "firebase/firestore";
import LibraryActivity from "../../../classes/LibraryActivity";

export const LISTEN_LIBRARY_ACTIVITY = (
  { dispatch },
  { where, limit, pagination, listenerPath, next, error, unlisten } = {}
) => {
  return dispatch("LISTEN_COLLECTION", {
    converter: LibraryActivity,
    path: LibraryActivity.getPath(),
    stateKey: "libraryActivity",
    listenerPath,
    where,
    limit,
    pagination,
    next,
    error,
    unlisten,
  });
};

export const GET_LIBRARY_ACTIVITY = (
  { dispatch },
  { where, limit, pagination } = {}
) => {
  return dispatch("GET_COLLECTION", {
    converter: LibraryActivity,
    stateKey: "libraryActivity",
    path: LibraryActivity.getPath(),
    where,
    limit,
    pagination,
  });
};

// Append an audit record. Called from the other library store actions so
// every user-initiated mutation leaves a trail. Best-effort: failures are
// logged but do not abort the underlying mutation.
export const LOG_LIBRARY_ACTIVITY = async ({ state }, entry) => {
  if (!entry || !entry.action || !state.user) return;
  const record = {
    at: new Date(),
    actorID: state.user.id,
    action: entry.action,
    subjectType: entry.subjectType || "",
    subjectID: entry.subjectID || null,
    subjectName: entry.subjectName || "",
    tier: entry.tier || "public",
    details: entry.details || null,
  };
  try {
    await addDoc(collection(db, LibraryActivity.getPath()), record);
  } catch (err) {
    console.error("Failed to log library activity", err);
  }
};
